import { RowDataConfig } from './utils';

export const WEEKEND_ROW_DATA_KEYS: RowDataConfig[] = [
  { shiftType: 'Day', diffKey: 'weDayShiftRateDiff', countKey: 'numOfWeDayShifts', tableIdx: 1 },
  {
    shiftType: 'Evening',
    diffKey: 'weEveShiftRateDiff',
    countKey: 'numOfWeEveShifts',
    tableIdx: 1,
  },
  {
    shiftType: 'Night',
    diffKey: 'weNightShiftRateDiff',
    countKey: 'numOfWeNightShifts',
    tableIdx: 1,
  },
];

export const HOLIDAY_ROW_DATA_KEYS: RowDataConfig[] = [
  { shiftType: 'Day', diffKey: 'holDayShiftRateDiff', countKey: 'numHolDayShifts', tableIdx: 2 },
  {
    shiftType: 'Evening',
    diffKey: 'holEveShiftRateDiff',
    countKey: 'numHolEveShifts',
    tableIdx: 2,
  },
  {
    shiftType: 'Night',
    diffKey: 'holNightShiftRateDiff',
    countKey: 'numHolNightShifts',
    tableIdx: 2,
  },
];

export const CALL_DAY_SHIFT_ROW_DATA_KEYS: RowDataConfig[] = [
  {
    shiftType: 'Weekday Day',
    diffKey: 'dayCallShiftRateDiff',
    countKey: 'numDayCallShifts',
    tableIdx: 0,
    isCallShift: true,
  },
  {
    shiftType: 'Weekday Evening',
    diffKey: 'eveCallShiftRateDiff',
    countKey: 'numEveCallShifts',
    tableIdx: 0,
    isCallShift: true,
  },
  {
    shiftType: 'Weekday Night',
    diffKey: 'nightCallShiftRateDiff',
    countKey: 'numNightCallShifts',
    tableIdx: 0,
    isCallShift: true,
  },
];

export const CALL_WEEKEND_SHIFT_ROW_DATA_KEYS: RowDataConfig[] = [
  {
    shiftType: 'Weekend Day',
    diffKey: 'weDayCallShiftRateDiff',
    countKey: 'numOfWeDayCallShifts',
    tableIdx: 1,
    isCallShift: true,
  },
  {
    shiftType: 'Weekend Evening',
    diffKey: 'weEveCallShiftRateDiff',
    countKey: 'numOfWeEveCallShifts',
    tableIdx: 1,
    isCallShift: true,
  },
  {
    shiftType: 'Weekend Night',
    diffKey: 'weNightCallShiftRateDiff',
    countKey: 'numOfWeNightCallShifts',
    tableIdx: 1,
    isCallShift: true,
  },
];

export const CALL_HOLIDAY_SHIFT_ROW_DATA_KEYS: RowDataConfig[] = [
  {
    shiftType: 'Holiday Day',
    diffKey: 'holDayCallShiftRateDiff',
    countKey: 'numHolDayCallShifts',
    tableIdx: 2,
    isCallShift: true,
  },
  {
    shiftType: 'Holiday Evening',
    diffKey: 'holEveCallShiftRateDiff',
    countKey: 'numHolEveCallShifts',
    tableIdx: 2,
    isCallShift: true,
  },
  {
    shiftType: 'Holiday Night',
    diffKey: 'holNightCallShiftRateDiff',
    countKey: 'numHolNightCallShifts',
    tableIdx: 2,
    isCallShift: true,
  },
];
